import { Search, Filter } from "lucide-react"
import { colors } from "../../styles/theme"

interface SearchFiltersProps {
  searchTerm: string
  onSearchChange: (value: string) => void
}

export function SearchFilters({ searchTerm, onSearchChange }: SearchFiltersProps) {
  return (
    <div className="mb-6">
      <div className="flex flex-col sm:flex-row gap-4">
        <div className="flex-1">
          <div className="relative">
            <Search
              className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4"
              style={{ color: colors.text.tertiary }}
            />
            <input
              type="text"
              placeholder="Search drag racing series..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
              style={{
                backgroundColor: colors.background.secondary,
                borderColor: colors.border.primary,
                color: colors.text.primary,
              }}
            />
          </div>
        </div>
        <div className="flex items-center gap-4">
          <button
            className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium border rounded-lg hover:opacity-80"
            style={{
              color: colors.text.primary,
              backgroundColor: colors.background.secondary,
              borderColor: colors.border.primary,
            }}
          >
            <Filter className="h-4 w-4" />
            Filter
          </button>
        </div>
      </div>
    </div>
  )
} 